import './Spinner.css'; // External CSS for cleanliness

const Spinner = ({ className }: { className?: string }) => {
    const ticks = Array.from({ length: 12 });

    return (
        <div className={`spinner ${className}`}>
            {ticks.map((_, i) => (
                <div
                    key={i}
                    className='spinner-tick'
                    style={{
                        transform: `rotate(${i * 30}deg) translateY(-170%)`,
                        animationDelay: `${-((11 - i) * 1) / 12}s`,
                    }}
                />
            ))}
        </div>
    );
};

export default Spinner;
